import * as actionTypes from '../actions/types';

const initialState = {
  stepIdStore: 0,
  stepIdMax: 0,
  journeyId: '',
  journeyName: '',
  journeyCompleted: false,
  industryName: '',
  checklistOne: false,
  checklistTwo: false,
  username: '',
  journeys: [],
  opportunities: [],
  isLoadingOpps: false,
  isLoadingSlides: false,
  isLoadingStageMap: false,
  slidesLink: '',
  toasts: [],
  milestoneCount: 1500,
  countdown: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_STEPID:
      return {
        ...state,
        stepIdStore: action.stepId,
      };
    case actionTypes.SET_MAX_STEP:
      return {
        ...state,
        stepIdMax: action.stepId,
      };
    case actionTypes.STORE_MILESTONE_COUNT:
      return {
        ...state,
        milestoneCount: action.milestoneCount,
    };
    case actionTypes.STORE_USERNAME:
      return {
        ...state,
        username: action.username,
      };
    case actionTypes.STORE_JOURNEY_NAME:
      return {
        ...state,
        journeyName: action.journeyName,
      };
    case actionTypes.STORE_INDUSTRY_NAME:
      return {
        ...state,
        industryName: action.industryName,
      };
    case actionTypes.STORE_CHECKLIST_ONE:
      return {
        ...state,
        checklistOne: action.checklistOne,
      };
    case actionTypes.STORE_CHECKLIST_TWO:
      return {
        ...state,
        checklistTwo: action.checklistTwo,
      };
    case actionTypes.STORE_JOURNEY_ID:
      return {
        ...state,
        journeyId: action.journeyId,
      };
    case actionTypes.SET_JOURNEYS:
      return {
        ...state,
        journeys: [...action.journeys],
      };

    case actionTypes.SET_OPPORTUNITIES:
      return {
        ...state,
        opportunities: [...action.opps],
      };
    case actionTypes.SET_JOURNEY_COMPLETED:
      return {
        ...state,
        journeyCompleted: action.journeyCompleted,
      };
    case actionTypes.SET_OPP_LOADING:
      return {
        ...state,
        isLoadingOpps: action.isLoading,
      };

    case actionTypes.SET_SLIDES_LOADING:
      return {
        ...state,
        isLoadingSlides: action.isLoading,
      };
    case actionTypes.SET_STAGEMAP_LOADING:
      return {
        ...state,
        isLoadingStageMap: action.isLoading,
      };
    case actionTypes.SET_SLIDES_LINK:
      return {
        ...state,
        slidesLink: action.slidesLink,
      };
    case actionTypes.ADD_TOAST:
      return {
        ...state,
        toasts: [action.toast],
      };
    case actionTypes.REMOVE_TOAST:
      return {
        ...state,
        toasts: state.toasts.filter((t) => t.id !== action.id),
      };

    case actionTypes.SET_COUNTDOWN:
    return {
      ...state,
      countdown: action.countdown,
    };

    default:
      return state;
  }
};
